/**
 * How to Play, over whatever is on screen (task 9.9).
 *
 * Mounted once at the application root so it is reachable mid-mission. It is an
 * overlay rather than a route on purpose: no navigation, no unmounting of the
 * run, and therefore no game time — closing it returns the player to the exact
 * state they left (`game-shell` spec, "Opened mid-mission").
 */
import type { JSX } from 'react';
import { Modal } from './Modal.js';
import { HowToPlayContent } from '../screens/HowToPlayScreen.js';
import { useViewStore } from '../store/view-store.js';

export function HelpOverlay(): JSX.Element | null {
  const open = useViewStore((state) => state.helpOpen);
  const setHelpOpen = useViewStore((state) => state.setHelpOpen);

  return (
    <Modal
      open={open}
      title="How to Play"
      description="Nothing here moves the clock. Close it to return to where you were."
      size="lg"
      testId="help-overlay"
      onClose={() => {
        setHelpOpen(false);
      }}
    >
      <HowToPlayContent />
    </Modal>
  );
}
